import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Course.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Video = makeShortcode("Video");
const FlashCard = makeShortcode("FlashCard");
const Prompt = makeShortcode("Prompt");
const Answer = makeShortcode("Answer");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`While Loops`}</h1>
    <p>{`In this video, you’ll learn how to use indefinite iteration in Python with while loops. Looping can
be tricky, so be sure to check your understanding with the flash card below!`}</p>
    <Video alt="While Loops" videoId="kwiul1KC5go" mdxType="Video" />
    <h2>{`Check Your Understanding`}</h2>
    <FlashCard mdxType="FlashCard">
      <Prompt mdxType="Prompt">
        <p>{`Walk through each iteration of the two loops below. What does the first loop print? What does the
second loop print?`}</p>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`count = 0

while count < 5:
    count += 1
    if count == 3:
        break

    print(count)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`count = 0

while count < 5:
    count += 1
    if count == 3:
        break

    print(count)
`}</code></pre>
      </Prompt>
      <Answer mdxType="Answer">
        <p>{`The first while loop prints out the sequence `}<inlineCode parentName="p">{`1, 2`}</inlineCode>{`.`}</p>
        <p>{`The second prints out the sequence `}<inlineCode parentName="p">{`1, 2, 4, 5`}</inlineCode>{`.`}</p>
        <p>{`This is because in the first loop, we use the keyword `}<inlineCode parentName="p">{`break`}</inlineCode>{` to completely exit the iteration when
`}<inlineCode parentName="p">{`count`}</inlineCode>{` is equal to 3. The second loop uses the keyword `}<inlineCode parentName="p">{`continue`}</inlineCode>{` in that same if statement, so the
loop skips the rest of that iteration of the code block (printing out the value 3) and jumps back to
the top of the loop. Try walking back through both loops one more time to cement your understanding
of using `}<inlineCode parentName="p">{`break`}</inlineCode>{` and `}<inlineCode parentName="p">{`continue`}</inlineCode>{`!`}</p>
      </Answer>
    </FlashCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      